<script>
	import UISection from "../ui/UISection.svelte";

	import router from "../stores/router";
	router.track();
</script>

<main>
	<UISection>
		<div class="Page404">
			<h2>NOT FOUND</h2>
			<p>ページが見つかりません</p>
		</div>
	</UISection>
</main>

<style global>
	.Page404 {
		text-align: center;
		padding: 8em 0 2em;
		color: #999;
	}
</style>
